module.controller('disableSubCtrl', ['$scope', '$state', '$http', 'cacheService', 'Transform', 'OVERLAY', 'baseURI','$stateParams', 'accountService', function ($scope, $state, $http, cacheService, Transform, OVERLAY, baseURI,$stateParams, accountService){
  var statusUrl = baseURI + 'card/status';
  var account = accountService.getAccount($stateParams.username);

  $scope.alert = {};
  $scope.alert.alertMessage = 'Sorry, we were unable to disable this card at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';
  $scope.overlay = OVERLAY['member.home.subcard/disable'];

  $scope.FirstName = account.firstName;
  $scope.LastName = account.lastName;

  $scope.attemptSubmission = function(){
    disableSub();
  };

  var disableSub = function(){
    $scope.loading = true;
    var disableReq = {
      Username: $stateParams.username,
      Status: 13
    };

    $http({
      method: 'PUT',
      url: statusUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(disableReq)
    }).then(function(resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        account.status = 'Inactive';
        account.statusCode = '13';
        accountService.updateAccounts([account]);
        $scope.alert.successShownOnly = true;
        $scope.alert.successMessageOnly = 'Your card has been successfully disabled.';
        $state.go('member.home.subaccount/disable.confirmation', account);
      } else {
        $scope.alert.alertShown = true;
      }
    }).catch(function (error){
      $scope.alert.alertShown = true;
      $scope.loading = false;
    });
  };
}]);
